function initialize() {
    $('.page-stores select[name="region"]').on('change', function (evt) {
        const region = $(this).find('option:selected').val();
        goRegions(region);
    });
}

function goRegions(region) {
    let url = '/compre-agora';

    if (region) {
        url += '/' + region;
    }

    window.location = url + '#lojas';
}

initialize();
